import { useAuth } from '../../contexts/AuthContext'

export const useDemoControls = (demoName: string) => {
  const { authFetch } = useAuth()

  const resetDemo = async () => {
    const response = await authFetch(`/api/demos/${demoName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clientName: demoName,
        businessId: null,
      }),
    })
    if (response.ok) {
      alert(`Successfully reset ${demoName} demo`)
      return
    }
    // eslint-disable-next-line no-console
    console.error(response)
    alert(`Failed to reset ${demoName} demo`)
  }

  const toggleSolopreneurLayout = async (current: boolean) => {
    const response = await authFetch(`/api/demos/${demoName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        useSolopreneurLayout: !current,
      }),
    })
    if (response.ok) {
      window.location.reload()
      return
    }
    // eslint-disable-next-line no-console
    console.error(response)
    alert('Failed to toggle solopreneur layout')
  }

  const toggleEnableTimeTracking = async (current: boolean) => {
    const response = await authFetch(`/api/demos/${demoName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        enableTimeTracking: !current,
      }),
    })
    if (response.ok) {
      window.location.reload()
      return
    }
    // eslint-disable-next-line no-console
    console.error(response)
    alert('Failed to toggle time tracking')
  }

  return {
    resetDemo,
    toggleSolopreneurLayout,
    toggleEnableTimeTracking,
  }
}
